export default __webpack_public_path__ + "static/media/warning.706d8abb.svg";